(function($){
    'use strict';

    var $inputBox  = $('.search__input'),
        serviceAll = $('.serviceall'),
        acceptedSuburbAdd;

    const suburbSearch = {
        sel: {
            search: '#find-suburb',
            searchMenu: '.search__input--menu',
            wrapper: '.find-suburb-wrapper',
            add: '.add-suburb',
            savedSuburbs: '.suburbs-serviced'
        },
        vars: {
            classNames: 'search__input',
            url: $inputBox.attr('data-typeahead') + '?partial_query=',
            wideBreakpoint: 1024,
            viewAll: 'View all results',
            keys: {
                ENTER: 13
            }
        },
        init() {
            this.initTypehead();
            this.setAutosuggestionWidth();
            this.sendQuery();
            this.addSuburb();
            this.removeMatrixSubmitAction();
            $(suburbSearch.sel.add).prop('disabled', true);
        },
        destroy() {
            const self = this;
            $(this.sel.search).typeahead('destroy');
            $(self.sel.wrapper).off('click', self.sel.add);
        },
        removeMatrixSubmitAction() {
            $('form').attr('onsubmit','');
        },
        initTypehead() {
            const self = this;
            $(this.sel.search).typeahead({
                name: 'suburb-search',
                hint: true,
                highlight: true,
                minLength: 3,
                classNames: {
                    input: self.vars.classNames + '--input',
                    hint: self.vars.classNames + '--hint',
                    menu: self.vars.classNames + '--menu',
                    dataset: self.vars.classNames + '--dataset',
                    suggestion: self.vars.classNames + '--suggestion',
                    empty: self.vars.classNames + '--empty',
                    open: self.vars.classNames + '--open',
                    cursor: self.vars.classNames + '--cursor',
                    highlight: self.vars.classNames + '--highlight',
                    selectable: self.vars.classNames + '--selectable'
                }
            },
            {
                name: 'data',
                async: true,
                limit: 10,
                source: function(query, sync, async) {
                    self.findMatches(query, async)
                },
                display: function(item){
                  return item.suburb + ', ' + item.postcode;
                },
                templates: {
                    suggestion: function(data) {
                        return `<div>${data.suburb}, ${data.postcode}</div>`;
                    },
                    empty: function(data) {
                        $(self.sel.add).prop('disabled', true);
                        return `<div class="no-result-text">No matches. Search again</div>`;
                    }
                }
            });
        },
        findMatches(query, cb) {
          const self = this;
          var matches = [],
              url = self.vars.url,
              storedSuburbsVal = $(self.sel.savedSuburbs).val(),
              currentStoredSuburbs = [],
              querySting = query.toLowerCase();

              // Add stored suburbs into array
              if(storedSuburbsVal) {
                currentStoredSuburbs = storedSuburbsVal.split(';');
              }

              fetch(url)
                  .then(res => res.json())
                  .then((res) => {
                      for(var i = res.length - 1; i >= 0; i--) {
                          var rawCat = res[i].suburb,
                              resCat = rawCat.toLowerCase(),
                              rawRelated = res[i].postcode,
                              resRelated = rawRelated.toString(),
                              storedSuburbStr = rawCat + ', ' + rawRelated,
                              alreadySaved = false,
                              noResults = '<div class="no-result-text">No matches. Search again</div>',
                              dataset = $('.search__input--dataset');

                          // Loop through list of locations to see if its already saved
                          for(var j = 0; j < currentStoredSuburbs.length; j++) {
                              function isInArray(value, array) {
                                return array.indexOf(value) > -1;
                              }

                              if(isInArray(storedSuburbStr, currentStoredSuburbs[j])) {
                                  alreadySaved = true;
                              }
                          }

                          // Remove items from results if no match or if its already saved
                          if (resCat.indexOf(querySting) === -1 && resRelated.indexOf(querySting) === -1 && storedSuburbStr.toLowerCase().indexOf(querySting) === -1 || alreadySaved) {
                              res.splice(i, 1);
                          }


                      }
                      cb(res);

                      // No results. Plugin no results not working
                      if(!res.length) {
                          dataset.html(noResults);
                          $('.search__input--menu').css('display', 'block');
                      }
                  }
              );
        },
        addSuburb() {
          const self = this;
          // Adding suburb event
          $(self.sel.wrapper).on('click', self.sel.add, function(){
              var suburbToAddEl = $('#find-suburb'),
                  suburbToAdd = $(suburbToAddEl).val(),
                  storedSuburbsEl = $(self.sel.savedSuburbs),
                  storedSuburbs = [];

              // Add existing stored suburbs
              if($(storedSuburbsEl).val()) {
                 storedSuburbs = $(self.sel.savedSuburbs).val().split(';');
              }

              // If suburb is not blank and exists in the valid suburb array
              if(suburbToAdd && acceptedSuburbAdd.indexOf(suburbToAdd) == -1 ) {
                  storedSuburbs.push(suburbToAdd);
                  $(storedSuburbsEl).val(storedSuburbs.join(";"));
                  suburbSearch.buildSuburbList();
                  $(suburbToAddEl).val('');
                  $(self.sel.add).prop('disabled', true);
                  self.destroy();
                  self.init();
              }
              else {
                  alert('Not a valid suburb. Enter a postcode or suburb name');
              }

              suburbShow();
          });
        },
        setAutosuggestionWidth() {
            if (window.innerWidth < this.vars.wideBreakpoint) {
                $(this.sel.searchMenu).css({
                    'width': $(this.sel.search).width() + 'px',
                    'left': '-10px'
                });
            }
        },
        sendQuery() {
            const self = this;

            // Custom select event
            $(this.sel.search).bind('typeahead:select', function(e, suggestion) {
                $(self.sel.add).prop('disabled', false);
                $(this).typeahead('close');
                $(this).val(suggestion.suburb + ', ' + suggestion.postcode);
            });

            // On autocomplete render, populate accepted suburbs added
            $(this.sel.search).bind('typeahead:render', function(e, suggestion, async, name) {
                var returnedArr = suggestion,
                    simplifiedArr = [];

                if(suggestion == undefined) {
                  returnedArr = 0;
                }
                for(var i = 0; i < returnedArr.length; i++) {
                    simplifiedArr.push(returnedArr[i].suburb + ', ' + returnedArr[i].postcode);
                }

                acceptedSuburbAdd = simplifiedArr;
            })

            // Clear the input field when closed
            $(this.sel.search).bind('typeahead:closed', function () {
                $(this).val("");
            });

            // Enter keystroke event
            $(this.sel.search).on('keyup', function(e) {
                const key = e.which;
                if (key === self.vars.keys.ENTER) {
                    e.preventDefault();
                }
                const searchValue = this.value;
                if (searchValue === '') {
                    // disable add button
                    $(suburbSearch.sel.add).prop('disabled', true);
                }
            });

            // Add name query to input field for accessibility
            $('.search__input--hint').attr({
                'name': 'suburb-hint',
                'title': 'Suburb hint'
            });

        },
        buildSuburbList() {
            const self = this;

            var storedSuburbs = $(self.sel.savedSuburbs).val(),
                storedSuburbsArr = [],
                suburbElWrapper = '<div class="stored-suburb-list"><p class="stored-suburbs-title">Suburbs serviced:</p></div>';

            // Restart list build
            $('.stored-suburb-list').remove();

            // Add existing stored suburbs onto page
            if(storedSuburbs) {
                storedSuburbsArr = storedSuburbs.split(';').sort();
                $(self.sel.wrapper).append(suburbElWrapper);


                for(var i = 0; i < storedSuburbsArr.length; i++) {
                    var markUp = '<div class="suburb-row">' + storedSuburbsArr[i] + '<button class="remove-suburb" value="' + storedSuburbsArr[i] + '" type="button">Remove</button> </div>'

                    $('.stored-suburb-list').append(markUp);
                }
            }

            // Remove event
            $('.stored-suburb-list').on('click', '.remove-suburb', function(){
                var suburbToRemove = this.value;

                for(var i = 0; i < storedSuburbsArr.length; i++) {
                  if(storedSuburbsArr[i] == suburbToRemove) {
                      storedSuburbsArr.splice(i,1);
                  }
                }

                // Update stored list and remove element
                $(self.sel.savedSuburbs).val(storedSuburbsArr.join(';'));
                $(this).parent().remove();

                // If list is empty remove element
                if(!storedSuburbsArr.length) {
                    $('.stored-suburb-list').remove();
                    $(serviceAll).prop('required', true);
                    $(serviceAll).attr('aria-required', 'true');
                }

                suburbShow();
            });

        }
    };

    suburbSearch.init();

    // Remove default form submit functionality
    $('.registration-form form').on('keyup keypress', function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            e.preventDefault();
            return false;
        }
    });

    // Apply submit on enter keypress on submit button
    $('#sq_commit_button').on('keyup keypress', function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            $('.registration-form form').submit();
        }
    });

    // Toggle assistance to all of Victoria
    function suburbShow() {
        var serviceAllChecked = $('.serviceall:checked'),
            storedSuburbs = $('.suburbs-serviced').val();

        if(typeof storedSuburbs === 'undefined'){
            storedSuburbs = 0;
        }
        // If all suburbs is empty and stored suburbs is empty
        if(!serviceAllChecked.length && !storedSuburbs.length) {
            $(serviceAll).prop('required', true);
            $(serviceAll).attr('aria-required', 'true');
        }
        else {
            $(serviceAll).prop('required', '');
            $(serviceAll).attr('aria-required', 'false');

        }

        if(serviceAllChecked.length) {
            $(suburbSearch.sel.wrapper).addClass('suburb-hide');
            $(suburbSearch.sel.savedSuburbs).val('');
        }
        else {
            $(suburbSearch.sel.wrapper).removeClass('suburb-hide');
            suburbSearch.buildSuburbList();
        }
    }

    // Adding event listener to all checkbox
    $('.serviceall').on('change', suburbShow);
    suburbShow();

    // Conditional fields - requires jQuery
    var conditionalFields = document.querySelectorAll('.conditional-field');

    function conditionalFieldShow() {
        for(let confield of conditionalFields) {
            var conditionalEl = confield,
                drivingFieldName = conditionalEl.getAttribute('data-driving-field'),
                drivingFieldReqVal = conditionalEl.getAttribute('data-driving-value'),
                drivingField = document.querySelectorAll('[name="' + drivingFieldName + '"]'),
                showField = false;

                for(let drivefield of drivingField) {
                    // Attach class to driving fields for attaching event
                    if(!drivefield.classList.contains('driving-field')) {
                        drivefield.classList.add('driving-field');
                    }

                    if(drivefield.type =='radio' && drivefield.checked && drivefield.value ==  drivingFieldReqVal) {
                        showField = true;
                        break;
                    }
                }

                // Show or hide conditional field
                if(showField) {
                    conditionalEl.classList.add('show-condition');
                }
                else {
                    conditionalEl.classList.remove('show-condition');
                }
        }
    }

    if(conditionalFields) {
        conditionalFieldShow();
        $('.driving-field').on('change', conditionalFieldShow);
    }

    const animalsCared = {
        el: {
            storageEl: document.querySelectorAll('.animals-cared')[0],
            animalCheckBoxes: document.querySelectorAll('[name="animals"]')
        },
        storeAnimals() {
            const self = this;
            let newAnimalsArray = [];

            for(let animal of self.el.animalCheckBoxes) {
                if(animal.checked) {
                    newAnimalsArray.push(animal.value);
                }
            }

            self.el.storageEl.value = newAnimalsArray.join(',');
        },
        load() {
            const self = this;
            let storedAnimalArray = self.el.storageEl.value.split(',');

            for(let animal of self.el.animalCheckBoxes) {
                if(storedAnimalArray.indexOf(animal.value) > -1) {
                   animal.checked = true;
                }
            }
        },
        init() {
            this.load();

            for(let animal of this.el.animalCheckBoxes) {
                animal.addEventListener('change', (event) => {
                    if(event.target.value == "all") {
                        let selected = event.target.checked;
                        for(let checkbox of this.el.animalCheckBoxes) {
                            checkbox.checked = selected;
                        }
                    }
                    this.storeAnimals();
                });
            }
        }
    }

    // Initiate
    if(document.getElementsByClassName('animals-cared').length) {
        animalsCared.init();
    }

    let toggleModal = document.querySelectorAll('.toggle-modal'),
        modal = document.querySelector('.iwt-tool-tac');

    for (let button of toggleModal) {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            modal.classList.toggle('hidden');
        });
    }


    // new open24/7 checkbox functionality
    // if open24/7 is checked, hide all time fields,
    // but also set some defaults
    const openHours = {
        'vars' : {
            'open247Checkbox': $('.open247-checkbox input[type="checkbox"]'),
            'setInitialTime' : {
                'startHour': true,
                'startMinute': true,
                'endHour': true,
                'endMinute': true
            }
        },
        'init' : function(){
            openHours.sanitiseMinuteSelect();
            openHours.toggleOpenHoursOptions();
            
            openHours.vars.open247Checkbox.on('click', function(){
                openHours.toggleOpenHoursOptions();
            });
            
            $('body').on('change', '.opening-hours .time-block:first-child select[id*="datetimevalue_h"]', openHours.setStartHours);
            $('body').on('change', '.opening-hours .time-block:first-child select[id*="datetimevalue_i"]', openHours.setStartMinutes);
            $('body').on('change', '.opening-hours .time-block:last-child select[id*="datetimevalue_h"]', openHours.setEndHours);
            $('body').on('change', '.opening-hours .time-block:last-child select[id*="datetimevalue_i"]', openHours.setEndMinutes);

        },
        'setStartHours' : function(){
            if(openHours.vars.setInitialTime.startHour){

                var $this = this;

                // set all start hours
                $('.opening-hours .time-block:first-child select[id*="datetimevalue_h"]').each(function(i){
                    this.selectedIndex = $this.selectedIndex;
                    $(this).selectric('refresh');
                });
                // and then disable the option
                openHours.vars.setInitialTime.startHour = false;
            }
        },
        'setStartMinutes' : function(){
            if(openHours.vars.setInitialTime.startMinute){

                var $this = this;

                // set all start hours
                $('.opening-hours .time-block:first-child select[id*="datetimevalue_i"]').each(function(i){
                    this.selectedIndex = $this.selectedIndex;
                    $(this).selectric('refresh');
                });
                // and then disable the option
                openHours.vars.setInitialTime.startMinute = false;
            }
        },
        'setEndHours' : function(){
            if(openHours.vars.setInitialTime.endHour){

                var $this = this;

                // set all start hours
                $('.opening-hours .time-block:last-child select[id*="datetimevalue_h"]').each(function(i){
                    this.selectedIndex = $this.selectedIndex;
                    $(this).selectric('refresh');
                });
                // and then disable the option
                openHours.vars.setInitialTime.endHour = false;
            }
        },
        'setEndMinutes' : function(){
            if(openHours.vars.setInitialTime.endMinute){

                var $this = this;

                // set all start hours
                $('.opening-hours .time-block:last-child select[id*="datetimevalue_i"]').each(function(i){
                    this.selectedIndex = $this.selectedIndex;
                    $(this).selectric('refresh');
                });
                // and then disable the option
                openHours.vars.setInitialTime.endMinute = false;
            }
        },

        'isCheckboxChecked' : function(selector){
            return selector.is(":checked");
        },
        'toggleOpenHoursOptions' : function(){
            var open247 = openHours.isCheckboxChecked(openHours.vars.open247Checkbox);
            // if the checkbox is checked on load
            if(open247){
                openHours.hideOpenHoursOptions();
            } else {
                openHours.showOpenHoursOptions();
            }
        },
        'showOpenHoursOptions': function(){
            $('.time-select, .hours-note').show();
        },
        'hideOpenHoursOptions': function(){
            openHours.setOpenHoursTo247();
            $('.time-select, .hours-note').hide();
            
        },
        'setOpenHoursTo247': function(){
            var timeBlocks = $('.time-select');
            // for each time block, set end times to 11:59pm
            for(var i = 0, ii = timeBlocks.length; i < ii; i++){
                var firstTimeBlock = $(timeBlocks[i]).find('.time-block:first');
                var lastTimeBlock = $(timeBlocks[i]).find('.time-block:last');
                firstTimeBlock.find('select[name*="metadata_field_date_"]').each(function(){
                    this.selectedIndex = 0;
                    $(this).selectric('refresh');
                });
                lastTimeBlock.find('select[name*="metadata_field_date_"]').each(function(){
                    var counter = this.options.length;
                    this.selectedIndex = counter - 1;
                    $(this).selectric('refresh');
                });
            }
        },
        'sanitiseMinuteSelect' : function(){
            var timeBlocks = $('.time-select');
            // for each time block, set end times to 11:59pm
            for(var i = 0, ii = timeBlocks.length; i < ii; i++){
                var timeBlock = $(timeBlocks[i]).find('.time-block');
                var times = ['00', '15', '30', '45'];
                timeBlock.find('select[id*="_datetimevalue_i"] option').each(function(){
                    // each minute select field
                    // only show 00 15 30 45 options
                    var thisOption = this;
                    var optionVal = this.text;
                    var match = times.indexOf(optionVal);
                    if(match == -1){
                        $(this).remove();
                    }
                });
            }
            $('select[id*="_datetimevalue_i"]').selectric('init');
        }
    };
    openHours.init();

}(jQuery));
